import axios from 'axios';
const personalLoanBackendPrefix = '/apps/personalloan';
export default {
	getKoForm() {
		return axios.get(personalLoanBackendPrefix + '/api/public/ko');
	},
	calculate(data) {
		return axios.post(personalLoanBackendPrefix + '/api/public/ko', data);
	}
};
